// @flow

import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import type { AtomProps } from './types';
import {
  Box,
  Input,
} from './atoms';
import type { Theme } from '../../../types';

type Props = {
  className: string,
  disabled?: boolean,
  onChange: Function,
  name: string,
  id?: string,
  checked?: boolean,
  error?: boolean,
};

class CheckBox extends Component<Props> {
  static defaultProps = {
    disabled: false,
    id: '',
    error: false,
    checked: false,
  };

  shouldComponentUpdate(nextProps: Props) {
    const { checked, disabled, error } = this.props;

    return nextProps.checked !== checked
      || nextProps.disabled !== disabled
      || nextProps.error !== error;
  }

  render() {
    const {
      checked = false,
      className,
      disabled,
      error = false,
      id,
      name,
      onChange,
    } = this.props;

    return (
      <div className={className}>
        <Input
          disabled={disabled}
          type="checkbox"
          checked={checked}
          onChange={e => !disabled && onChange && onChange(e.target.checked)}
          name={name}
          id={id || name}
        />
        <Box checked={checked || false} disabled={disabled} error={error}>
          <Icon className="icon-check" checked={checked} error={error} />
        </Box>
      </div>
    );
  }
}

const Icon = styled<any, Theme, AtomProps>('i')`
  display: none;
  font-size: .7rem;
  line-height: 0;
  &:before {
    vertical-align: middle;
  }
  ${props => props.checked && css`
    display: block;
    color: ${props.theme.form.checkbox.iconColor};
  `}
`;

export default styled<typeof CheckBox, Theme>(CheckBox)`
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  margin-top: 0.1em;
  margin-right: 1.2em;
`;
